{
  "courses": {
    "title": "Cursos y Formación",
    "createButton": "Nuevo curso",
    "createStudentButton": "Nuevo estudiante",
    "createTitle": "Crear curso",
    "editTitle": "Editar curso",
    "backToList": "Volver a cursos",
    "searchPlaceholder": "Buscar por título o lugar...",
    "allStatuses": "Todos los estados",
    "allLevels": "Todos los niveles",
    "noData": "No se encontraron cursos",
    "noTeacher": "Sin profesor",
    "nextSession": "Próxima sesión:",
    "columns": {
      "title": "Título",
      "level": "Nivel",
      "duration": "Duración",
      "price": "Precio",
      "status": "Estado",
      "nextSession": "Próxima sesión",
      "fill": "Ocupación",
      "teachers": "Profesores"
    },
    "level": {
      "Basic": "Básico",
      "Intermediate": "Intermedio",
      "Expert": "Experto",
      "ExpertFinishes": "Experto — Acabados"
    },
    "status": {
      "Draft": "Borrador",
      "Published": "Publicado",
      "Archived": "Archivado"
    },
    "sessionStatus": {
      "Scheduled": "Programada",
      "Open": "Abierta",
      "Full": "Completa",
      "Cancelled": "Cancelada",
      "Completed": "Completada"
    },
    "form": {
      "title": "Título",
      "titleRequired": "El título es obligatorio",
      "description": "Descripción",
      "level": "Nivel",
      "status": "Estado",
      "durationMinutes": "Duración (minutos)",
      "location": "Lugar",
      "language": "Idioma",
      "maxStudents": "Máx. estudiantes",
      "price": "Precio (EUR)"
    },
    "archive": {
      "title": "Archivar curso",
      "confirm": "¿Archivar \"{{title}}\"?",
      "action": "Archivar"
    },
    "sessions": {
      "title": "Sesiones",
      "empty": "Sin sesiones por ahora",
      "noComing": "Sin sesiones próximas",
      "showPast": "Mostrar pasadas ({{count}})"
    },
    "session": {
      "createButton": "Añadir sesión",
      "createTitle": "Añadir sesión",
      "editTitle": "Editar sesión",
      "date": "Fecha",
      "startTime": "Hora de inicio",
      "endTime": "Hora de fin",
      "location": "Lugar",
      "country": "País",
      "availableSeats": "Plazas disponibles",
      "status": "Estado",
      "seats": "plazas",
      "until": "hasta",
      "enrollments": "Inscripciones",
      "students": "Estudiantes",
      "noStudents": "Sin estudiantes inscritos",
      "addStudent": "Añadir estudiante",
      "edit": "Editar sesión",
      "deleteTitle": "Eliminar sesión",
      "deleteConfirm": "¿Estás seguro de que quieres eliminar esta sesión? Se eliminarán todas las inscripciones.",
      "complete": "Finalizar",
      "reopen": "Reabrir"
    },
    "enroll": {
      "title": "Inscribir estudiante",
      "button": "Inscribir",
      "action": "Inscribir",
      "search": "Buscar estudiantes",
      "searchPlaceholder": "Escribir para buscar...",
      "student": "Estudiante",
      "studentPlaceholder": "Seleccionar estudiante...",
      "noResults": "No se encontraron estudiantes",
      "noEnrollments": "Sin inscripciones aún",
      "remove": "Dar de baja",
      "removeTitle": "Eliminar inscripción",
      "removeConfirm": "¿Eliminar a {{name}} de esta sesión?",
      "columns": {
        "name": "Nombre",
        "email": "Email",
        "enrolledAt": "Inscrito el"
      }
    },
    "teachers": {
      "title": "Profesores",
      "add": "Añadir profesor",
      "empty": "Sin profesor asignado",
      "assign": "Asignar",
      "removeTitle": "Retirar profesor",
      "removeConfirm": "¿Retirar a {{name}} de este curso?",
      "select": "Seleccionar profesor..."
    },
    "enrollmentStatus": {
      "Registered": "Inscrito",
      "Attended": "Asistido",
      "Completed": "Completado",
      "Cancelled": "Cancelado"
    },
    "attendance": {
      "edit": "Editar asistencia",
      "present": "Presente",
      "absent": "Ausente",
      "comment": "Comentario",
      "commentTitle": "Añadir un comentario",
      "commentPlaceholder": "Comentario (opcional)..."
    },
    "create": {
      "successTitle": "Curso creado",
      "successMessage": "El curso ha sido creado con éxito.",
      "errorTitle": "Error",
      "errorMessage": "No se pudo crear el curso."
    }
  }
}